import { cn } from "../../lib/utils";

const tones = {
  white: {
    section: "bg-white",
    kicker: "text-complement-600",
    title: "text-shark-950",
    accent: "bg-complement-500/70",
    lead: "text-shark-500",
    decor: false,
  },
  tint: {
    section: "bg-shark-50/60",
    kicker: "text-complement-600",
    title: "text-shark-950",
    accent: "bg-complement-500/70",
    lead: "text-shark-500",
    decor: false,
  },
  dark: {
    section: "bg-shark-950 text-white",
    kicker: "text-burnt-sienna-400",
    title: "text-white",
    accent: "bg-complement-500",
    lead: "text-white/70",
    decor: true,
  },
};

export default function ServiceSectionShell({
  kicker,
  title,
  lead,
  tone = "white",
  children,
}) {
  const t = tones[tone] || tones.white;

  return (
    <div
      className={cn(
        "relative overflow-hidden px-4 py-16 lg:px-8 lg:py-20",
        t.section
      )}
    >
      {t.decor && (
        <>
          <div
            className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_65%_50%_at_20%_0%,rgba(231,109,56,0.1),transparent_60%)]"
            aria-hidden
          />
          <div
            className="pointer-events-none absolute -right-[8%] top-[15%] h-[420px] w-[420px] rounded-full bg-complement-500/8 blur-[140px]"
            aria-hidden
          />
          <div
            className="pointer-events-none absolute bottom-0 left-[10%] h-[260px] w-[260px] rounded-full bg-burnt-sienna-500/[0.07] blur-[120px]"
            aria-hidden
          />
        </>
      )}

      <div className="relative mx-auto max-w-6xl">
        <div className="max-w-3xl">
          <p
            className={cn(
              "text-[11px] font-bold uppercase tracking-[0.22em]",
              t.kicker
            )}
          >
            {kicker}
          </p>
          <h2
            className={cn(
              "mt-4 max-w-2xl text-[clamp(1.625rem,3vw,2.25rem)] font-extrabold leading-[1.12] tracking-tight",
              t.title
            )}
          >
            {title}
          </h2>
          {lead && (
            <>
              <div
                className={cn("mt-6 h-px w-10", t.accent)}
                aria-hidden
              />
              <p
                className={cn(
                  "mt-5 max-w-[620px] text-[0.98rem] leading-[1.65]",
                  t.lead
                )}
              >
                {lead}
              </p>
            </>
          )}
        </div>

        <div className="mt-10">{children}</div>
      </div>
    </div>
  );
}
